
class Carousel extends HTMLElement {
    static ELEMENT_NAME = 'carousel-js';

    constructor() {
        super();
        this.contentScroll = this.querySelector('.carousel-js-content');
        this.prevButton = this.querySelector('.carousel-js-prev');
        this.nextButton = this.querySelector('.carousel-js-next');

        this.handlePrevClick = this.handlePrevClick.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        this.resetScroll = this.resetScroll.bind(this);
        this.connectedCallback = this.connectedCallback.bind(this);

        this.getCurrentItem = this.getCurrentItem.bind(this);
        this.getTotalItems = this.getTotalItems.bind(this)
        this.setCurrentItem = this.setCurrentItem.bind(this);
        this.getItemList = this.getItemList.bind(this);
        this.updateScroll = this.updateScroll.bind(this);
        this.getAnimating = this.getAnimating.bind(this);
        this.setAnimating = this.setAnimating.bind(this);
        this.updateButtons = this.updateButtons.bind(this);
        this.handleScroll = this.handleScroll.bind(this);

        this.connectedCallback();
        this.resetScroll();
    }

    getAnimating() {
        return this.getAttribute('animating');
    }

    setAnimating(value) {
        this.setAttribute('animating', value);
    }


    resetScroll() {
        this.setCurrentItem(0)
        this.updateScroll();
    }

    getItemList() {
        return this.contentScroll.querySelectorAll('[js-carousel-item]');
    }

    getCurrentItem() {
        const currentItem = Array.from(this.getItemList()).findIndex((item) => item.classList.contains('active'));
        return currentItem;
    }

    getTotalItems() {
        return this.getItemList().length;
    }

    setCurrentItem(currentItem) {
        if(this.getAnimating() === 'true') {
            return;
        }
        const items = this.getItemList();
        items.forEach((item, index) => {
            if (index === currentItem) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });
    }

    connectedCallback() {
        this.prevButton.addEventListener('click', this.handlePrevClick.bind(this));
        this.nextButton.addEventListener('click', this.handleNextClick.bind(this));
        this.contentScroll.addEventListener('touchend', this.handleScroll.bind(this));
    }

    handleScroll() {
        const items = this.getItemList();
        const scrollLeft = this.contentScroll.scrollLeft;
        const width = this.contentScroll.offsetWidth;
        const middle = scrollLeft + width / 2;
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const left = item.offsetLeft - this.contentScroll.offsetLeft;
            const right = left + item.offsetWidth;
            if (middle >= left && middle <= right) {
                this.setCurrentItem(i);
                this.updateButtons();
                this.updateScroll();
                break;
            }
        }
    }


    handlePrevClick() {
        if (this.getCurrentItem() > 0) {
            this.setCurrentItem(this.getCurrentItem() - 1)
        }

        this.updateScroll();
    }

    handleNextClick() {
        if (this.getCurrentItem() < this.getTotalItems() -1) {
            this.setCurrentItem(this.getCurrentItem() + 1)
        }

        this.updateScroll();
    }

    updateScroll() {
        const currentItem = this.contentScroll.querySelector(`[js-carousel-item]:nth-child(${this.getCurrentItem() + 1})`);
        if(!currentItem) return;
        const scrollLeft = currentItem.offsetLeft - this.contentScroll.offsetLeft;
        this.setAnimating('true');
        setTimeout(() => {
            this.setAnimating('false');
            this.updateButtons();
        }, 50);
        this.contentScroll.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
        });        
    }

    updateButtons() {
        if (this.getCurrentItem() === 0) {
            this.prevButton.classList.add('hidden');
        } else {
            this.prevButton.classList.remove('hidden');
        }

        if (this.getCurrentItem() === this.getTotalItems() - 1) {
            this.nextButton.classList.add('hidden');
        } else {
            this.nextButton.classList.remove('hidden');
        }
    }
}

if (!customElements.get(Carousel.ELEMENT_NAME)) {
    customElements.define(Carousel.ELEMENT_NAME, Carousel);
}
  
